// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
// 解决ie axios预请求兼容问题
import "babel-polyfill";

import VideoPlayer from "vue-video-player";
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");

Vue.use(VideoPlayer);

import ElementUI from "element-ui";
import AppInfoParser from "app-info-parser";
// import enLocale from 'element-ui/lib/locale/lang/en'
import enLocale from "./assets/Element-Lang/en.js";
import zhLocale from "./assets/Element-Lang/zh-CN.js";
import jaLocale from "./assets/Element-Lang/ja.js";
import enJson from "./assets/lang/en";
import cnJson from "./assets/lang/cn";
import jaJson from "./assets/lang/ja";
import VueI18n from "vue-i18n";
import HttpPlugIn from "./plugins/http.js";
import axios from "axios";
import ApiProvider from "./services/api.provider.js";
import HelperProvider from "./services/helper.provider.js";
import Validator from "./plugins/validator.js";
import ThemeProvider from "./services/theme.provider.js";
import Cookie from "./services/cookie.provider.js";
import store from "./services/store.provider.js";
import * as Filters from "./services/filter.provider.js";
import echarts from "echarts";
import moment from "moment";
import VueQuillEditor from "vue-quill-editor";
// require styles 引入样式
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import PasswordInput from "vant";
import VueParticles from "vue-particles";
import components from "./plugins/components.js";

import BaiduMap from "vue2-baidu-map";
Vue.use(BaiduMap, { ak: "vqOd14k7GfOTNqqeSdPbVk93aR0MRh9n", type: "WebGL" });

Vue.use(VueParticles);
Vue.use(VueQuillEditor);
Vue.use(PasswordInput);
Vue.use(VueI18n);
Vue.use(components);

Vue.prototype.$theme = ThemeProvider;
Vue.prototype.AppInfoParser = AppInfoParser;
Vue.prototype.$http = HttpPlugIn;
Vue.prototype.$axios = axios;
Vue.prototype.$api = ApiProvider;
Vue.prototype.$helper = HelperProvider;
Vue.prototype.$validator = Validator;
Vue.prototype.$cookie = Cookie;
Vue.prototype.$bus = new Vue();
Vue.prototype.$echarts = echarts;
Vue.prototype.$moment = moment;

Object.keys(Filters).forEach(key => {
  Vue.filter(key, Filters[key]);
});

const messages = {
  en: {
    ...enJson.login, //登录
    ...enJson.headerLang, //头部导航栏
    ...enJson.Aside, //左侧导航栏
    ...enJson.common, //公用
    ...enJson.projectOverviewLang, //项目概览
    ...enJson.deviceoverviewLang, //设备管理
    ...enJson.energyConsumLang, //能耗管理
    ...enJson.alarmManagementLang, //报警管理
    ...enJson.maintenanceManagementLang, //维保管理
    ...enJson.noticeManagementLang, //运维通知
    ...enJson.systemSettinManagementLang, //系统配置
    ...enJson.personalSettingLang, //个人中心
    ...enJson.news,
    ...enJson.roleList,
    ...enJson.staffManagement,
    ...enJson.newStaff,
    ...enJson.empowerPeople,
    ...enJson.visitorManagement,
    ...enJson.viewVisitorItinerary,
    ...enJson.visitorAuthenticationRecord,
    ...enJson.conferenceRoomManagement,
    ...enJson.newConferenceRoom,
    ...enJson.bookingDetails,
    ...enJson.locationManagement,
    ...enJson.newLoaction,
    ...enJson.generalSettings,
    ...enJson.rests,
    ...enJson.projectOverviewLang,
    ...enJson.nenghao,
    ...enJson.deviceManagement,
    ...enLocale
  },
  zh: {
    ...cnJson.login, //登录
    ...cnJson.headerLang, //头部导航栏
    ...cnJson.Aside, //左侧导航栏
    ...cnJson.common, //公用
    ...cnJson.projectOverviewLang, //项目概览
    ...cnJson.deviceoverviewLang, //设备管理
    ...cnJson.energyConsumLang, //能耗管理
    ...cnJson.alarmManagementLang, //报警管理
    ...cnJson.maintenanceManagementLang, //维保管理
    ...cnJson.noticeManagementLang, //运维通知
    ...cnJson.systemSettinManagementLang, //系统配置
    ...cnJson.personalSettingLang, //个人中心
    ...cnJson.news,
    ...cnJson.roleList,
    ...cnJson.staffManagement,
    ...cnJson.newStaff,
    ...cnJson.empowerPeople,
    ...cnJson.visitorManagement,
    ...cnJson.viewVisitorItinerary,
    ...cnJson.visitorAuthenticationRecord,
    ...cnJson.conferenceRoomManagement,
    ...cnJson.newConferenceRoom,
    ...cnJson.bookingDetails,
    ...cnJson.locationManagement,
    ...cnJson.newLoaction,
    ...cnJson.generalSettings,
    ...cnJson.rests,
    ...cnJson.projectOverviewLang,
    ...cnJson.nenghao,
    ...cnJson.deviceManagement,
    ...cnJson.maintenanceManagement,
    ...zhLocale
  },
  ja: {
    ...jaJson.login, //登录
    ...jaJson.headerLang, //头部导航栏
    ...jaJson.Aside, //左侧导航栏
    ...jaJson.common, //公用
    ...jaJson.projectOverviewLang, //项目概览
    ...jaJson.deviceoverviewLang, //设备管理
    ...jaJson.energyConsumLang, //能耗管理
    ...jaJson.alarmManagementLang, //报警管理
    ...jaJson.maintenanceManagementLang, //维保管理
    ...jaJson.noticeManagementLang, //运维通知
    ...jaJson.systemSettinManagementLang, //系统配置
    ...jaJson.personalSettingLang, //个人中心

    ...jaJson.roleList,
    ...jaJson.staffManagement,
    ...jaJson.newStaff,
    ...jaJson.empowerPeople,
    ...jaJson.visitorManagement,
    ...jaJson.viewVisitorItinerary,
    ...jaJson.visitorAuthenticationRecord,
    ...jaJson.conferenceRoomManagement,
    ...jaJson.newConferenceRoom,
    ...jaJson.bookingDetails,
    ...jaJson.locationManagement,
    ...jaJson.newLoaction,
    ...jaJson.generalSettings,
    ...jaJson.rests,
    ...jaJson.projectOverviewLang,
    ...jaJson.nenghao,
    ...jaJson.deviceManagement,
    ...jaJson.maintenanceManagement,
    ...jaLocale
  }
};

// 设置默认语言
// 读取浏览器语言
let lang;
let navLang = navigator.language || navigator.userLanguage;
let navLangArr = navLang.split("-");
if (navLang.indexOf("zh") > -1 || navLang.indexOf("en") > -1) {
  lang = localStorage.getItem("browser-lang") || navLangArr[0] || "en";
  localStorage.setItem("browser-lang", lang);
} else {
  lang = "en";
  localStorage.setItem("browser-lang", lang);
}

const i18n = new VueI18n({
  locale: lang,
  messages: {
    zh: messages.zh,
    en: messages.en,
    ja: messages.ja
  }
});
Vue.prototype.resetSetItem = function(key, newVal) {
  if (key === "asideList") {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent("StorageEvent");
    const storage = {
      setItem: function(k, val) {
        sessionStorage.setItem(k, val);

        // 初始化创建的事件
        newStorageEvent.initStorageEvent(
          "setItem",
          false,
          false,
          k,
          null,
          val,
          null,
          null
        );

        // 派发对象
        window.dispatchEvent(newStorageEvent);
      }
    };
    return storage.setItem(key, newVal);
  }
};

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
var vm = new Vue({
  el: "#app",
  store,
  router,
  i18n,
  components: { App },
  template: "<App/>"
});
export default vm;



// WEBPACK FOOTER //
// ./src/main.js